import { render } from "./InboxItem.vue?vue&type=template&id=72eb6572"
import script from "./InboxItem.vue?vue&type=script&lang=ts"
export * from "./InboxItem.vue?vue&type=script&lang=ts"
script.render = render

export default script